import { debounce, isArray, isEmpty, isNull, toNumber } from 'lodash';
import * as React from 'react';
import Select from 'react-select';
import { isNullOrUndefined } from 'util';

import { IControlError, IControlSchema } from '../../core/Controls';

import { IDispatcher } from '../helpers/Dispatcher';
import {
  buildUrl,
  Component,
  getUrlParamsForDropbox,
  I18NString,
} from '../helpers/Utils';

import ErrorAlert from './components/ErrorAlert';
import Field from './components/Field';

export interface IDropBoxOptionSchema {
  key: string | number;
  value: I18NString;
}

export interface IDropBoxSchema extends IControlSchema {
  description: I18NString;
  notification: I18NString;
  options: Array<IDropBoxOptionSchema>;
  value?: any;
  disabled?: boolean;
  multi?: boolean;
  extra?: any;
  widget?: any;
  countries?: Array<any>;
  flows?: Array<any>;
  // TODO: DynamicOptions - Заменить
  dynamicOptions: any;
  data?: {
    url: string;
    query?: Record<string, string>;
    direction?: boolean;
    urlParams?: { [key: string]: string };
  };
}

export interface IDropBoxProps {
  schema: IDropBoxSchema;
  api: any;
  dispatcher?: IDispatcher;
  error: IControlError | undefined;
  visited: boolean;
  dynamicOptions?: any;
}

interface OptionsType {
  [key: string]: unknown;
  value: string;
  label: string;
}

interface State {
  isLoading: boolean;
  options: Array<OptionsType>;
  openInfo: boolean;
  isOpenNotification: boolean;
  statusField?: boolean;
}

const mappingOptions = (array): Array<OptionsType> => {
  if (!Array.isArray(array)) {
    return [];
  }

  return array?.map(
    (item): OptionsType => ({
      ...item,
      value: item?.key || item?.id || item?.name,
      label: item?.name,
    }),
  );
};

const findOptionsById = (arr, id, key) => {
  if (!Array.isArray(arr)) {
    return {};
  }
  return arr?.filter((item) => item?.name === id).find((item) => item?.[key])?.[
    key
  ];
};

export class DropBox extends Component<IDropBoxProps, State> {
  static controls = {
    select: null,
  };

  state = {
    isLoading: false,
    options: [],
    openInfo: false,
    isOpenNotification: true,
  };

  constructor(props) {
    super(props);
    // TODO: УБРАТЬ ДЕБАУНС и ДОБАвИТЬ addMultiplyValues
    // @ts-ignore
    this.emitBlurDebounced = debounce(this.emitBlur, 200);
  }

  componentDidMount() {
    const {
      api,
      schema: { urlParams, data, disabled, value, required },
    } = this.props;

    let _urlParams = '';

    if (data?.urlParams && urlParams) {
      _urlParams = getUrlParamsForDropbox(data, urlParams);
    }

    if (data?.url) {
      this.setState({ isLoading: true });
      const dataUrlSubstituted = buildUrl(data.url, api.options);

      if (!api.options.baseUrl) {
        new Error('Исправьте конфигурацию, не добавлен baseUrl');
      }
      api?.moduleApi?.get(
        `${api.options.baseUrl}${dataUrlSubstituted}${_urlParams}`,
        data?.query || null,
        {
          success: (response) => {
            const options = mappingOptions(response.data);

            this.setState({
              options,
              isLoading: false,
            });
          },
          error: () => {
            this.setState({ isLoading: false });
          },
        },
      );
    }

    // TODO: unused Status
    if (required) {
      if (!value && !disabled) {
        // eslint-disable-next-line react/no-unused-state
        this.setState({ statusField: true });
      } else {
        // eslint-disable-next-line react/no-unused-state
        this.setState({ statusField: false });
      }
    } else {
      // eslint-disable-next-line react/no-unused-state
      this.setState({ statusField: true });
    }
  }

  componentWillUnmount() {
    // @ts-ignore
    this.emitBlurDebounced.cancel();
  }

  onClick = () => {
    this.setState(({ openInfo }) => ({
      openInfo: !openInfo,
    }));
  };

  emitBlur = (select) => {
    const { dispatcher, schema } = this.props;

    for (const key in schema.extra.writeValueInId) {
      if (!select?.[key]) {
        continue;
      }
      dispatcher.onAddValueRefresh(
        schema.extra.writeValueInId[key],
        select?.[key]?.toString() || null,
        undefined,
      );
    }
  };

  protected onChange = (select) => {
    const { dispatcher, schema } = this.props;

    // TODO: REPLACE ADD_VALUE_MULTIPLY
    if (schema?.extra?.drawDynamicOptions) {
      Object.keys(schema?.extra?.drawDynamicOptions).forEach((key) => {
        dispatcher.setDynamicOption({
          selectType: key,
          options: findOptionsById(
            this.props.dynamicOptions?.[schema?.widget?.selectType],
            select?.name,
            key,
          ),
        });
      });
    }

    if (isArray(select)) {
      dispatcher.onAddValueRefresh(
        schema.id,
        isEmpty(select) ? null : select,
        undefined,
      );
    } else {
      // eslint-disable-next-line no-nested-ternary
      const value: string = isNull(select)
        ? null
        : toNumber(select.value) === 0
        ? null
        : String(select.value);
      dispatcher.onAddValueRefresh(
        schema.id,
        isNull(value) ? null : value.toString(),
        undefined,
      );

      if (schema?.extra?.writeValueInId) {
        // @ts-ignore
        this.emitBlurDebounced(select);
      }
    }
  };

  onOpenNotification = () => {
    this.setState(({ isOpenNotification }) => ({
      isOpenNotification: !isOpenNotification,
    }));
  };

  render() {
    const { isLoading } = this.state;
    const {
      schema: {
        data,
        disabled,
        description,
        notification,
        multi,
        value,
        controlValue,
        options,
        widget,
        countries,
        flows,
        extra,
      },
      visited,
      error,
      dynamicOptions,
    } = this.props;

    const errorMessage = visited && error && error.message;

    // TODO: need rebuild and use state options
    let arr = [];

    // TODO: need rebuild and use helper
    if (typeof options !== 'undefined') {
      arr = options.map((o: IDropBoxOptionSchema) => ({
        value: o.key,
        label: o.value.ru,
      }));
    }

    // УДАЛИТЬ - как перейдут все флоу и кантри
    // TODO: need rebuild and use helper
    // TODO: DRY
    if (
      typeof widget !== 'undefined' &&
      widget.selectType === 'country' &&
      !data?.url
    ) {
      if (typeof countries !== 'undefined')
        arr = countries
          .filter((item) => item.name.length > 0)
          .map((item) => ({
            value: item.asu_id,
            label: item.name,
          }))
          .sort((a, b) => {
            if (a.label < b.label) {
              return -1;
            }
            if (a.label > b.label) {
              return 1;
            }
            return 0;
          });
    }

    // TODO: need rebuild and use helper
    // TODO: need rebuild and use state options
    // TODO: DRY
    if (
      typeof widget !== 'undefined' &&
      widget.selectType === 'flow' &&
      !data?.url
    ) {
      if (typeof flows !== 'undefined')
        arr = flows
          .filter((item) => item.name.length > 0)
          .map((item) => ({
            value: item.id,
            label: item.name,
          }))
          .sort((a, b) => {
            if (a.label < b.label) {
              return -1;
            }
            if (a.label > b.label) {
              return 1;
            }
            return 0;
          });
    }

    // TODO: need rebuild and use state options
    if (
      widget &&
      dynamicOptions &&
      !['flow', 'country'].includes(widget.selectType)
    ) {
      arr = mappingOptions(dynamicOptions?.[widget?.selectType]);

      const isExist = arr.some((opt) => opt.value === (controlValue || value));

      if (!isExist && disabled) {
        arr = [
          ...arr,
          { value: controlValue || value, label: controlValue || value },
        ];
      }
    }

    return (
      <Field
        {...this.props.schema}
        status={
          isNullOrUndefined(controlValue || value) ? 'default' : 'success'
        }
      >
        {extra && extra.hint && (
          <div
            className="alert alert-info hint"
            dangerouslySetInnerHTML={{ __html: extra.hint }}
          />
        )}
        <div className="input-group">
          {!isLoading ? (
            <Select
              autosize={false}
              multi={multi}
              name="form-field-name"
              className="has-success"
              placeholder="Выберите из списка"
              value={controlValue || value}
              disabled={disabled}
              style={{
                width: '100%',
                borderColor: controlValue || value ? '#4eb43e' : '#ccc',
              }}
              onChange={this.onChange}
              clearable={false}
              noResultsText="Список пуст"
              options={arr?.length ? arr : this.state.options}
            />
          ) : (
            <p> Загрузка...</p>
          )}
          {notification && (
            <span
              onClick={this.onOpenNotification}
              className="input-group-addon btn btn-default"
            >
              <span className="glyphicon glyphicon-info-sign" />
            </span>
          )}
          {description && (
            <span
              onClick={this.onClick}
              className="input-group-addon btn btn-default"
            >
              <span className="glyphicon glyphicon-question-sign" />
            </span>
          )}
        </div>
        {notification && this.state.isOpenNotification && (
          <div
            className="alert alert-warning"
            role="alert"
            dangerouslySetInnerHTML={{
              __html: this.tr(this.props.schema.notification),
            }}
          />
        )}
        {description && this.state.openInfo && (
          <div
            className="alert alert-warning"
            role="alert"
            dangerouslySetInnerHTML={{
              __html: this.tr(this.props.schema.description),
            }}
          />
        )}
        <ErrorAlert errorMessage={errorMessage} />
      </Field>
    );
  }
}

export function createDropBox(
  schema: IControlSchema,
  api: any,
  dispatcher: IDispatcher = null,
  error: IControlError | undefined,
  visited: boolean,
  dynamicOptions: any,
): React.ReactElement<any> {
  return (
    <DropBox
      schema={schema as IDropBoxSchema}
      api={api}
      dispatcher={dispatcher}
      error={error}
      visited={visited}
      dynamicOptions={dynamicOptions}
    />
  );
}
